module.exports = __webpack_public_path__ + "static/media/galerija_2014 (31).254ce97c.jpg";